import React, { useState, useRef, useMemo, useEffect } from "react";
import { Drawer, Anchor } from "antd";
import styles from "./index.module.scss";
import { Button } from "app/(new-pages)/components/Button/pc/index.pc";
import { LeftArrowSvg, TopArrowSvg } from "./svg";
import { Checkbox, Col, Row } from "antd";
import LocationSelectPc from "../allSelect/LocationSelect/pc";
import IndustrySelectPc from "../allSelect/IndustrySelect/pc";
import SalarySelectPc from "../allSelect/SalarySelect/pc";
import BenefitsSelectPc from "../allSelect/BenefitsSelect/pc";
import classNames from "classnames";

interface initProps {
  data: any;
  isRemote?: boolean;
  open: boolean;
  onClose: () => void;
  setSelectCount?: (e: number) => void;
  onConfirm?: (e: any) => void;
  hideMenu?: boolean;
  value?: any;
  preferenceId?: string;
  locationValue?: any;
}
const initObj = {
  location: { region: [], location: [] },
  company_industry: [],
  language: [],
  job_type: [],
  xp_lvl: [],
  degree: [],
  company_size: [],
  company_financing_stage: [],
  salary: { salary_type: [], salary: [] },
  benefit: { category_value: [], benefits: [] }
};

const DrawerFilter = ({
  data = {},
  isRemote = false,
  onClose,
  open,
  setSelectCount,
  onConfirm = () => {},
  hideMenu = false,
  value,
  preferenceId = "",
  locationValue
}: initProps) => {
  const {
    job_detail_text,
    job_requirement_text,
    company_detail_text,
    remote_location_text,
    company_benefit_text,
    remote_location_filter,
    location_text,
    location_filter,
    language_text,
    language_filter,
    industry_text,
    job_type_text,
    job_type_filter,
    xp_lvl_text,
    xp_lvl_filter,
    degree_text,
    degree_filter,
    company_size_text,
    company_size_filter,
    financing_stage_text,
    financing_stage_filter,
    benefits_text,
    benefits_filter,
    salary_text,
    salary_filter,
    select_text,
    industry_filter_h5,
    remote_benefits_filter,
    filter_text,
    clear_filter_text,
    apply_filter_text,
    filter_header_text
  } = data as any;

  const targetDivRefs = useRef([]);
  const [filter, setFilter] = useState(initObj);
  const [count, setCount] = useState(0);
  const [shrink, setShrink] = useState({
    jobType: true,
    xpLvl: true,
    degree: true,
    financingStage: true,
    language: true,
    companySize: true
  });

  const locationFilter = isRemote ? remote_location_filter : location_filter;

  useEffect(() => {
    if (open && value) {
      setFilter((item) => ({
        ...item,
        company_financing_stage: value.company_financing_stage?.split(",") || [],
        company_size: value.company_size?.split(",") || [],
        degree: value.degree?.split(",") || [],
        job_type: value.job_type ? value.job_type?.split(",") : [],
        xp_lvl: value.xp_lvl?.split(",") || [],
        company_industry: value.company_industry ? value.company_industry?.split(",") : []
      }));
    }
  }, [value, open]);

  useEffect(() => {
    if (locationValue) {
      setFilter((item) => ({
        ...item,
        location: locationValue
      }));
    }
  }, [locationValue]);
  useEffect(() => {
    if (preferenceId) {
      onClear();
    }
  }, [preferenceId]);

  useEffect(() => {
    const {
      location,
      company_industry,
      language,
      job_type,
      xp_lvl,
      degree,
      company_size,
      company_financing_stage,
      salary,
      benefit
    } = filter;

    let selectedLocations = 0;
    if (!location?.location.length && location?.region?.length) {
      // only region selected
      let regionSet = new Set(location?.region);

      locationFilter.find((item) => {
        if (regionSet.has(item.seo_value)) {
          selectedLocations += item?.locations?.length || 0;
        }
      });
    }

    const groups = [
      ...location?.location,
      ...company_industry,
      ...language,
      ...job_type,
      ...xp_lvl,
      ...degree,
      ...company_size,
      ...company_financing_stage,
      ...salary?.salary,
      ...benefit?.benefits
    ].filter(Boolean);

    setCount(groups.length + selectedLocations);
  }, [filter, locationFilter]);

  // console.log("location__", locationFilter);

  // const filterEmptyValues = (obj) => {
  //   return Object.keys(obj).reduce((acc, key) => {
  //     if (obj[key] !== null && obj[key] !== undefined && obj[key] !== "") {
  //       acc[key] = obj[key];
  //     }
  //     return acc;
  //   }, {});
  // };
  const handelConfirm = (filter) => {
    const {
      location,
      company_industry,
      language,
      job_type,
      xp_lvl,
      degree,
      company_size,
      company_financing_stage,
      salary,
      benefit
    } = filter;
    const params = {
      region: location?.region?.join(","),
      location: location?.location?.join(","),
      salary_type: salary?.salary_type?.join(","),
      salary: salary?.salary?.join(","),
      job_type: job_type?.join(","),
      xp_lvl: xp_lvl?.join(","),
      degree: degree?.join(","),
      company_industry: company_industry?.join(","),
      company_size: company_size?.join(","),
      company_financing_stage: company_financing_stage?.join(","),
      language: language?.join(","),
      benefit: benefit?.benefits?.join(",")
    };
    onConfirm(params);
  };
  const onClear = () => {
    setFilter(initObj);
  };
  return (
    <Drawer
      data-role='my-job-more-filters'
      className={styles.drawerFilter}
      width={hideMenu ? 600 : 800}
      closeIcon={
        <div style={{ display: "flex", alignItems: "center", gap: 20, padding: "6px 6px 6px 0" }}>
          {LeftArrowSvg} {filter_header_text}
        </div>
      }
      title={filter_text}
      placement='right'
      onClose={onClose}
      open={open}
      extra={
        <div style={{ display: "flex", gap: "8px" }}>
          <Button variant='primaryTextBtn' onClick={onClear} btnSize='size36'>
            {clear_filter_text}
          </Button>
          <Button
            type='primary'
            variant='primaryBtn'
            onClick={() => {
              setSelectCount && setSelectCount(count);
              handelConfirm && handelConfirm(filter);
              onClose && onClose();
            }}
            btnSize='size36'
            className={styles.applyFilterBtn}
          >
            {apply_filter_text} {count > 0 ? <>({count})</> : null}
          </Button>
        </div>
      }
    >
      <div className={styles.container}>
        {!hideMenu && (
          <div className={styles.menu}>
            <Anchor
              bounds={40}
              getContainer={() => document.getElementById("filterContainer")}
              items={[
                {
                  key: "part-1",
                  href: "#part-1",
                  title: job_detail_text
                },
                {
                  key: "part-2",
                  href: "#part-2",
                  title: job_requirement_text
                },
                {
                  key: "part-3",
                  href: "#part-3",
                  title: company_detail_text
                },
                {
                  key: "part-4",
                  href: "#part-4",
                  title: company_benefit_text
                }
              ]}
            ></Anchor>
          </div>
        )}
        <div
          className={classNames([
            styles.main,
            {
              [styles.mainBgColour]: hideMenu
            }
          ])}
          id='filterContainer'
        >
          <div
            className={styles.group}
            ref={(el) => {
              targetDivRefs.current[0] = el;
            }}
            id='part-1'
          >
            {remote_location_filter || location_filter ? (
              <div className={styles.selectItem}>
                <p className={styles.title}>{isRemote ? remote_location_text : location_text}</p>
                <div className={styles.chooseItem}>
                  <LocationSelectPc
                    label={location_text}
                    location_filter={locationFilter}
                    value={filter.location}
                    placeholder={select_text}
                    onChange={(data) => {
                      setFilter({
                        ...filter,
                        location: data
                      });
                    }}
                    searchBoardPlaceholder={select_text}
                    realTimeRefresh={true}
                    wrapperClassName={styles.w100}
                  />
                </div>
              </div>
            ) : null}

            {isRemote ? (
              <>
                <div className={styles.selectItem}>
                  <p className={styles.title}>
                    {language_text}{" "}
                    <span
                      onClick={() =>
                        setShrink({
                          ...shrink,
                          language: !shrink.language
                        })
                      }
                      className={shrink.language ? null : styles.shrink}
                    >
                      {TopArrowSvg}
                    </span>
                  </p>
                  {shrink.language && (
                    <div className={styles.chooseItem}>
                      <Checkbox.Group
                        style={{ width: "100%" }}
                        value={filter.language}
                        onChange={(data) => {
                          setFilter({
                            ...filter,
                            language: data
                          });
                        }}
                      >
                        <Row>
                          {language_filter.map((item) => (
                            <Col span={12} key={item.id}>
                              <Checkbox value={item.id} key={item.id}>
                                {item.value}
                              </Checkbox>
                            </Col>
                          ))}
                        </Row>
                      </Checkbox.Group>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                {industry_filter_h5 ? (
                  <div className={styles.selectItem}>
                    <p className={styles.title}>{industry_text}</p>
                    <div className={styles.chooseItem}>
                      <IndustrySelectPc
                        value={filter.company_industry}
                        label={industry_text}
                        placeholder={select_text}
                        onChange={(data) => {
                          setFilter({
                            ...filter,
                            company_industry: data
                          });
                        }}
                        data={industry_filter_h5}
                        realTimeRefresh={true}
                        wrapperClassName={styles.w100}
                      />
                    </div>
                  </div>
                ) : null}
              </>
            )}

            {job_type_filter ? (
              <div className={styles.selectItem}>
                <p className={styles.title}>
                  {job_type_text}
                  <span
                    onClick={() =>
                      setShrink({
                        ...shrink,
                        jobType: !shrink.jobType
                      })
                    }
                    className={shrink.jobType ? null : styles.shrink}
                  >
                    {TopArrowSvg}
                  </span>
                </p>
                {shrink.jobType && (
                  <div className={styles.chooseItem}>
                    <Checkbox.Group
                      style={{ width: "100%" }}
                      value={filter.job_type}
                      onChange={(data) => {
                        setFilter({
                          ...filter,
                          job_type: data
                        });
                      }}
                    >
                      <Row>
                        {job_type_filter?.map((item) => (
                          <Col span={12} key={item.seo_value}>
                            <Checkbox value={item.seo_value} key={item.seo_value}>
                              {item.value}
                            </Checkbox>
                          </Col>
                        ))}
                      </Row>
                    </Checkbox.Group>
                  </div>
                )}
              </div>
            ) : null}
          </div>
          <div
            className={styles.group}
            ref={(el) => {
              targetDivRefs.current[1] = el;
            }}
            id='part-2'
          >
            <div className={styles.selectItem}>
              <p className={styles.title}>
                {xp_lvl_text}{" "}
                <span
                  onClick={() =>
                    setShrink({
                      ...shrink,
                      xpLvl: !shrink.xpLvl
                    })
                  }
                  className={shrink.xpLvl ? null : styles.shrink}
                >
                  {TopArrowSvg}
                </span>
              </p>
              {shrink.xpLvl && (
                <div className={styles.chooseItem}>
                  <Checkbox.Group
                    style={{ width: "100%" }}
                    value={filter.xp_lvl}
                    onChange={(data) => {
                      setFilter({
                        ...filter,
                        xp_lvl: data
                      });
                    }}
                  >
                    <Row>
                      {xp_lvl_filter?.map((item) => (
                        <Col span={12} key={item.seo_value}>
                          <Checkbox value={item.seo_value} key={item.seo_value}>
                            {item.value}
                          </Checkbox>
                        </Col>
                      ))}
                    </Row>
                  </Checkbox.Group>
                </div>
              )}
            </div>
            <div className={styles.selectItem}>
              <p className={styles.title}>
                {degree_text}{" "}
                <span
                  onClick={() =>
                    setShrink({
                      ...shrink,
                      degree: !shrink.degree
                    })
                  }
                  className={shrink.degree ? null : styles.shrink}
                >
                  {TopArrowSvg}
                </span>
              </p>
              {shrink.degree && (
                <div className={styles.chooseItem}>
                  <Checkbox.Group
                    style={{ width: "100%" }}
                    value={filter.degree}
                    onChange={(data) => {
                      setFilter({
                        ...filter,
                        degree: data
                      });
                    }}
                  >
                    <Row>
                      {degree_filter?.map((item) => (
                        <Col span={12} key={item.seo_value}>
                          <Checkbox value={item.seo_value} key={item.seo_value}>
                            {item.value}
                          </Checkbox>
                        </Col>
                      ))}
                    </Row>
                  </Checkbox.Group>
                </div>
              )}
            </div>
          </div>
          <div
            className={styles.group}
            ref={(el) => {
              targetDivRefs.current[2] = el;
            }}
            id='part-3'
          >
            <div className={styles.selectItem}>
              <p className={styles.title}>
                {company_size_text}{" "}
                <span
                  onClick={() =>
                    setShrink({
                      ...shrink,
                      companySize: !shrink.companySize
                    })
                  }
                  className={shrink.companySize ? null : styles.shrink}
                >
                  {TopArrowSvg}
                </span>
              </p>
              {shrink.companySize && (
                <div className={styles.chooseItem}>
                  <Checkbox.Group
                    style={{ width: "100%" }}
                    value={filter.company_size}
                    onChange={(data) => {
                      setFilter({
                        ...filter,
                        company_size: data
                      });
                    }}
                  >
                    <Row>
                      {company_size_filter?.map((item) => (
                        <Col span={12} key={item.seo_value}>
                          <Checkbox value={item.seo_value} key={item.seo_value}>
                            {item.value}
                          </Checkbox>
                        </Col>
                      ))}
                    </Row>
                  </Checkbox.Group>
                </div>
              )}
            </div>
            <div className={styles.selectItem}>
              <p className={styles.title}>
                {financing_stage_text}{" "}
                <span
                  onClick={() =>
                    setShrink({
                      ...shrink,
                      financingStage: !shrink.financingStage
                    })
                  }
                  className={shrink.financingStage ? null : styles.shrink}
                >
                  {TopArrowSvg}
                </span>
              </p>
              {shrink.financingStage && (
                <div className={styles.chooseItem}>
                  <Checkbox.Group
                    style={{ width: "100%" }}
                    value={filter.company_financing_stage}
                    onChange={(data) => {
                      setFilter({
                        ...filter,
                        company_financing_stage: data
                      });
                    }}
                  >
                    <Row>
                      {financing_stage_filter?.map((item) => (
                        <Col span={12} key={item.seo_value}>
                          <Checkbox value={item.seo_value} key={item.seo_value}>
                            {item.value}
                          </Checkbox>
                        </Col>
                      ))}
                    </Row>
                  </Checkbox.Group>
                </div>
              )}
            </div>
          </div>
          <div
            className={styles.group}
            ref={(el) => {
              targetDivRefs.current[3] = el;
            }}
            id='part-4'
          >
            {isRemote ? null : (
              <>
                {salary_filter ? (
                  <div className={styles.selectItem}>
                    <p className={styles.title}>{salary_text}</p>
                    <SalarySelectPc
                      value={filter.salary}
                      label={salary_text}
                      placeholder={select_text}
                      onChange={(data) => {
                        setFilter({
                          ...filter,
                          salary: data
                        });
                      }}
                      salary_filter={salary_filter}
                      realTimeRefresh={true}
                      wrapperClassName={styles.w100}
                    />
                  </div>
                ) : null}
              </>
            )}

            {remote_benefits_filter || benefits_filter ? (
              <div className={styles.selectItem}>
                <p className={styles.title}>{benefits_text}</p>
                <div>
                  <BenefitsSelectPc
                    value={filter.benefit}
                    label={benefits_text}
                    placeholder={select_text}
                    onChange={(data) => {
                      setFilter({
                        ...filter,
                        benefit: data
                      });
                    }}
                    realTimeRefresh={true}
                    benefits_filter={isRemote ? remote_benefits_filter : benefits_filter}
                    wrapperClassName={styles.w100}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default DrawerFilter;
